export default {
    title: "AELU",
    ssv: "Ур чадварын тодорхой виз",
    what_ssv: "Ур чадварын тодорхой виз",
    representative_message: "Төлөөлөгчийн мессеж",
    aeru_feature: "AELU-ийн онцлог шинж чанарууд",
    aeru_how_to_use: "Ашиглалтын урсгал",
    aeru_q_a: "Асуулт, Хариулт",
    aeru_function: "AELU-ийн үйл ажиллагаа",
    aeru_fee: "AELU-ийн төлбөр",
    login: "Нэвтрэх",
    db_top_comment1: "Салбартаа анх удаа! Тодорхой ур чадварын визний шалгалт -ын онлайн ухаалаг гар утасны сургалтын сайт.",
    db_top_comment2: "AELU бол шалгалт, шалгалтын мэдээлэл, мэдүүлгийн агентлагт суралцах замаар тодорхой ур чадварын виз авахыг дэмждэг вэб үйлчилгээ юм.",
    db_top_pr: "Шинэ боломжийг ашиглахын тулд Ур чадварын тодорхой визээ ашиглаарай.",
    member_regist: "Гишүүдийн бүртгэл",
    registration_support_organization: "Бүртгэлийг дэмжих байгууллага гэж юу вэ?",
    rso_dec1: "Ур чадварын тодорхой системд тодорхой ур чадварын харьяа байгууллага, бүртгэлийг дэмжих байгууллага гэсэн хоёр байгууллага байдаг. Ур чадварыг эзэмшсэн тодорхой байгууллага нь тодорхой ур чадвартай гадаадын иргэдийг ажиллуулдаг компани (хүлээн авах байгууллага) юм. Тодорхой ур чадварыг эзэмшдэг байгууллага нь ажлын байран, өдөр тутмын амьдрал, нийгэмд тодорхой ур чадвартай гадаадын иргэдэд дэмжлэг үзүүлэх ёстой.",
    rso_dec2: "Тодорхой ур чадвартай гадаадын иргэдийг дэмжих чиглэлээр мэргэшсэн агуулга байдаг тул тодорхой ур чадварын харьяалагддаг байгууллага гэсэн тодорхой ур чадвартай гадаадын иргэдийг ажиллуулдаг компанид дэмжлэг үзүүлэхэд хүндрэлтэй тохиолдол байдаг. Бүртгэлийг дэмжих байгууллага нь тодорхой ур чадвартай харийнханд дэмжлэг үзүүлэх төлөвлөгөө боловсруулж хэрэгжүүлэх тодорхой ур чадварын харьяа байгууллагад даалгасан байгууллагыг хэлнэ.",
    rso_dec3: "Бүртгэлийг дэмжих байгууллага нь тодорхой ур чадвартай харийнханд дэмжлэг үзүүлэх төлөвлөгөө боловсруулж хэрэгжүүлэх тодорхой ур чадварын харьяа байгууллагад даалгасан байгууллагыг хэлнэ.",
    rso_dec4: "Бүртгэлийг дэмжих байгууллага нь хүлээн авагч байгууллагатай дэмжлэгийн ачааны гэрээ байгуулан 1-рт заасан ур чадвар бүхий харь гарагийн иргэнийг дэмжих төлөвлөгөөнд үндэслэн бүх дэмжлэгийг үзүүлэх болно.",
    rso_dec5: "○ Бүртгэлийг дэмжих байгууллага болохын тулд Японы Цагаачлалын товчооны Комиссар бүртгүүлэх шаардлагатай.",
    rso_dec6: "○ Бүртгэгдсэн байгууллагуудыг бүртгэлийг дэмжих байгууллагын бүртгэлд бүртгүүлж, Японы Цагаачлалын товчооны вэбсайт дээр байрлуулна.",
    rso_dec7: "○ Бүртгэлийн хугацаа 5 жил бөгөөд сунгах шаардлагатай.",
    rso_dec8: "○ Бүртгэлийг дэмжих байгууллагууд Японы Цагаачлалын албанд хүссэн үедээ янз бүрийн мэдэгдэл гаргаж байх шаардлагатай.",
    article1: "Ур чадварын тодорхой виз гэж юу вэ?",
    article1_dec1: "2018 оны 12-р сарын 8-ны өдөр Цагаачлалын хяналтын тухай хуулийг шинэчлэн баталснаар орон байрны тодорхой ур чадварын статус шинээр байгуулагдав. 2019 оны 4-р сард хэрэгжиж эхэлсэн.",
    article1_dec2: "Оршин суух тодорхой ур чадварын шинэ статусыг хоёр үе шаттайгаар бий болгоно. (№ 1 ба № 2)",
    article1_dec3: "Зорилтот салбарууд нь 14 салбар юм.,",
    article1_dec4: "Гадаадын иргэдийн зорилтот шаардлага бол нэлээд мэдлэг, туршлага шаарддаг ур чадвартай хүн юм. Өөрөөр хэлбэл, гурван жилийн хугацаатай техникийн дадлагажигч мэргэжлээр төгссөн эсвэл түүнтэй дүйцэх хэмжээний Япон хэл, ур чадварын шалгалтанд тэнцсэн хүмүүс хамрагдах боломжтой юм.",
    article1_dec5: "Тодорхой ур чадвар No1 нь тодорхой ур чадвартай хүний хувьд 5 жил хүртэл хугацаагаар үлдэхийг зөвшөөрдөг. Гэр бүлийн гишүүдийг зөвшөөрөхгүй.",
    article1_dec6: "Мэргэшсэн ур чадвар эзэмшсэн хүний хувьд Тодорхой ур чадвар No2-т Тодорхой ур чадварын 1-р хугацаанд мэргэшсэн шалгалт өгч ерөнхий ажил эрхлэлттэй тэнцэх оршин суух статус өгдөг. \n (Оршин суух хугацааг сунгаснаар та амьдрах боломжтой үүрд мөн гэр бүлээ авчирч болно.),",
    article2: "Төлөөлөгчийн мессеж",
    article2_sub1: "Японоос одоохондоо татгалзаж болохгүй",
    article2_dec1: "Японд техникийн дадлагажигчаар ирж, ур чадвар эзэмшсэн, улс орныхоо хөгжлийн төлөө хүчин чармайлтаа харамгүй зориулж ирсэн олон техникийн дадлагажигч, буцаж ирсэн дадлагажигчдад чин сэтгэлийн талархал илэрхийлье. Өнөөдөр Японд байдаггүй гэр бүлийнхээ төлөө, эх орныхоо төлөө бясалгал хийж байгаа нь хүний анхны дүр төрх гэж би боддог. Намайг техникийн дадлагажигч бэлтгэх бизнест удаан хугацаагаар оролцож байсан боловч тус улсад зөвхөн техникийн дадлагажигч оюутны визээр нэвтрэх боломж байдаггүй бөгөөд би энэ боломжийг ашиглан Японд тууштай дадлага хийж, өөрийн бизнесээ нээдэг өөрийн улс, миний улс маш их хөгжиж байна. Би маш их зүйлийг харсан. Гэсэн хэдий ч 2019 оны 4-р сард тогтоосон хэдэн жилийн хугацаанд бүрэн сурч чадахгүй Японоос таашаал авах хүслийг хангахуйц визний тусгай ур чадварын визийг гаргалаа. Японд ховор тохиолддог, тэдний нүдний ард амбицтай, Японд зочлох олон гадаад хүмүүс Японыг хамтдаа хөгжүүлж чадна гэж найдаж байна. Хамгийн гол нь би Япон шиг хүмүүстэй болж, байнгын оршин суугчдын тоог нэмэгдүүлж, хамтдаа амьдрах нийгмийг бий болгохыг хүсч байна.",
    article2_dec2: "Visualization Co., Ltd.",
    article2_dec3: "Ерөнхийлөгч ба гүйцэтгэх захирал",
    article2_dec4: "Казухико Хориучи",
    article3: "AELU-ээс өгсөн гурван онцлог шинж чанарууд",
    article3_sub1: "Онлайн шалгалтанд хамрагдах",
    article3_sub1_dec1: "Ухаалаг гар утсан дээрх ур чадварын тодорхой тестэд бэлтгэх боломжийг олгодог AELU нь өнгөрсөн 14 асуултыг оруулаад бүх 14 салбарын 30 асуултын дараа хуурамч асуулт бэлтгэдэг бөгөөд шалгалтын өдөр хүртэл хэдэн ч удаа арга хэмжээ авах боломжтой. Хэрэв та хиймэл оюун ухаанаас гаргасан асуултанд заасан оноогоо давсан бол шалгалтаа заавал өгөх болно!",
    article3_sub2: "Шалгалтын мэдээлэл",
    article3_sub2_dec1: "Японд ирсэн гадаадын зочдод ойлгоход төвөгтэй тестийн мэдээллийг сонгогдсон салбарын туршилтын мэдээллийг бүртгүүлсний дараа шинэчлэх үед автоматаар нэмж хэрэглэгчид мэдэгдэх болно.",
    article3_sub3: "Шалгалтын мэдүүлгийн агентлаг",
    article3_sub3_dec1: "Шалгалтын мэдээллийн нэгэн адил Японд ирсэн гадаадын зочдод шалгалт өгөх өргөдөл гаргах нь маш хэцүү бөгөөд онлайн журам бөглөөгүй байж шалгалтаа өгөх боломжгүй юм. Бүртгүүлэхдээ та мэдээллээ байршуулж, анкеттайгаа хамт байж, шалгалтын зартай зэрэгцүүлэн өргөдөл гаргах боломжтой.",
    article4: "Туршилтыг давсны дараа функцын танилцуулга",
    article4_sub1: "Амжилтанд тэнцсэн өргөдөл гаргагчдад баяр хүргэе \n Бэлэн мөнгө буцааж (дотоодын болон олон улсын)",
    article4_sub1_dec1: "Хэрэв та аль хэдийн Японд амьдарч, AELU ашиглан дамжуулж, нэвтрэх дугаар, нэвтрэх гэрчилгээгээ хэрэглэгчийн дэлгэцэн дээрээ байршуулсан бол тухайн өдөртөө бэлэн мөнгө буцааж авах боломжтой. Бэлэн мөнгө буцааж өгөх төлөвлөгөө Бүтээгдэхүүн: Онлайн бэлгийн гэрчилгээ (Амазоны бэлгийн гэрчилгээний имэйл) Төрөл, Googleplay, iTunes бэлгийн карт) LINE-ийн албан ёсны данснаас 5000 иенийн бэлэн мөнгө буцааж авах.",
    article4_sub2: "Найзтайгаа танилцуулах кампанит ажил",
    article4_sub2_dec1: "Японд эсвэл гадаадад байгаа Японд байгаа өргөдөл гаргагчдыг FB бүлэгт элсэхийг урь, хэрэглэгч өөрөө удирдлагын дугаараа хэлж, тухайн дугаартай холбоотой хүнд бэлэн мөнгө буцааж өгөх бөгөөд танилцуулагчид 1000 онлайн бэлгийн гэрчилгээ өгөх болно. элссэнээс хойш сарын дараа. Иен бэлэн мөнгө буцааж авах.",
    article4_sub3: "Виз авсны дараа ажил хайх нь \n хиймэл оюун ухааныг автоматаар тохируулах (шийдээгүй)",
    article4_sub3_dec1: "AELU ашиглан баталгаажуулалтын шалгалтанд тэнцсэний дараа нэвтрэх дугаар болон нэвтрэх гэрчилгээг хэрэглэгчийн дэлгэц дээр байршуулснаар та Японы бүх компаниудаас автоматаар санал авах болно. Ярилцлагыг мөн онлайнаар хийх бөгөөд урьдчилсан албан бус бүлэгт хүртэл онлайнаар холбогдон тухайн улсад нэвтрэн орж, нүүж, ажилд орох боломжтой болно!",
    article4_sub4: "Оршин суух үнэмлэхээ тогтмол шалгах \n Бэлэн мөнгө буцааж өгөх (шийдээгүй),",
    article4_sub4_dec1: "Хэрэв та оршин суух үнэмлэхээ сард нэг удаа оршин суух үнэмлэх шалгах One Check Tab програм дээр шалгаагүй бол нэг жилийн дотор 10,000 иен бэлэн мөнгө буцааж авах болно.,",
    article5: "Тодорхой функцын танилцуулга,",
    article5_sub1: "Та шийдсэн асуудлаа эргэж харах боломжтой",
    article5_sub1_dec1: "Та онлайнаар сургасан шалгалтын агуулгыг хуримтлуулж, өөрийн багаж хэрэгслийг ашиглан хэрэглэгчдийн дадал зуршлыг ойлгож, чадваргүй асуудлаа даван туулж чадна. Та шалгалтанд хэдэн ч удаа бэлдэх боломжтой тул онооны түүх, туршилтын хугацааг бүгдийг тэмдэглэж, шалгалтын бодит өдөртэй аль болох ойртуул. Нэмж дурдахад та өөрийн хэл дээр болон япон хэл дээр бичигдсэн тул асуултыг илүү сайн ойлгож чадна.",
    article5_sub2: "Анкетаа оруулахдаа анкетаа бүрмөсөн хадгалаарай",
    article5_sub2_dec1: "Тодорхой ур чадварын визний шалгалтанд хамрагдаж, виз мэдүүлэхдээ Японд техникийн дадлагажигчаар ороход анкет хэрэгтэй болно. Анх менежментийн байгууллага (хоршоо) эсвэл илгээгч байгууллагад хадгалагдаж байсан тул тодорхой ур чадварын виз авсны дараа өөрөө хадгалах боломжтой.",
    article5_sub3: "Танай улсын болон салбарын бүртгэлийн үйл ажиллагаа,",
    article5_sub3_dec1: "Нэгэнт өөрийн орны болон Японы хэлийг хамт ашигладаг тул та асуултуудыг сайн ойлгож, хариу арга хэмжээ авах боломжтой. Анхны шалгалтанд зөвхөн Япон хэл авах боломжтой тул та зөвхөн Япон хэл дээр арга хэмжээ авах боломжтой.,",
    article5_sub4: "Баталгаажуулалтын шалгалтын шаардлага, мэдээллийг сануулах",
    article5_sub4_dec1: "Хүссэн мэргэжлээрээ ажиллах туршилтын хуваарийг туршилтын бүлэг тус бүрээр HP-д байршуулахад автоматаар сануулж, хэрэглэгчид мэдэгдэх бөгөөд хэрэглэгчийн дэлгэц дээр туршилтын огноог тохируулж, таймер автоматаар ажиллах болно.",
    article5_sub5: "Скрининг ашиглан суралцах",
    article5_sub5_dec1: "Та хэрэглэгчийн сул талыг гаргаж, шалгалтанд бэлдэж болно.",
    article5_sub6: "Ухаалаг гар утасны камер ашиглан онлайн сургалтын зөвлөгөө, ярилцлага.",
    article5_sub6_dec1: "Aer ашиглан шалгалтын бэлтгэл ажиллуулах явцдаа асуултын утга, зорилгыг онлайн дуудлага, чат хэлбэрээр тодруулах боломжтой болно. Энэ нь Японд дассан эсвэл танил болсон хүмүүст шаардлагагүй байж болох ч дуудлагын анхан шатны зөвлөгөө өгөх үйлчилгээ нь шалгалтын өмнө аливаа асуудлыг шалгаж үзэх хамгийн найдвартай арга юм!",
    article6: "Төлбөр",
    article6_sub1: "AELU ашиглалтын төлбөр",
    article6_sub1_dec1: "Та тодорхой ур чадварын визний шалгалтанд ямар ч хязгаарлалтгүйгээр суралцах боломжтой. Та онлайнаар төрөлх хэлээрээ зөвлөгөө авах боломжтой. * Та үүнийг ердийн үед орчуулагч болгон ашиглаж болно. \n Шалгалтын байранд зар өгөх нь шалгалт өгөх өдөр боломжтой. \n Орсоны дараа үргэлжлүүлэн үргэлжлүүлэн хадгалах боломжтой. \n Шалгалтаа өгсний дараа хүссэн мэргэжлээ танилцуулахын тулд тодорхой ур чадварын визний дугаараа бүртгүүлээрэй. (Шийдвэргүй).",
    article6_sub2: "Шалгалтын мэдүүлгийн агентлаг",
    article6_sub2_dec1: "Та ажлын үеэр өргөдөл гаргах боломжгүй бөгөөд өргөдөл гаргаагүй тохиолдолд гэрчилгээ олгох шалгалтанд хамрагдах боломжгүй тул шалгалтын өдрийг алдахгүйн тулд гэрчилгээ олгох шалгалтын мэдээлэл гарсан тохиолдолд бид шууд өргөдөл гаргана.",
    article7: "Cashback кампанит ажил үргэлжилж байна!",
    article7_dec1: "Шалгалтанд тэнцсэн хүмүүсээс энэхүү үйлчилгээний визний дугаарыг бүртгүүлсэн хүмүүс 5,000 \n иенийн мөнгөн буцааж авах болно! Аянд хэрхэн оролцохыг энд дарж үзнэ үү.",
    article8: "Одоо AELU-д бүртгүүлье!",
    dashboard: "Хяналтын самбар",
    member_info: "Профайлын мэдээллийг бүртгэх",
    first_name: "Нэр",
    midle_name: "дунд нэр",
    family_name: "Овог",
    half_width_Roman: "Ромажи хагас өргөн",
    password: "нууц үг",
    password_confirm: "Нууц үгийн баталгаажуулалт",
    mail_adress: "мэйл хаяг",
    lineId: "Шугамын дугаар",
    country_id: "Улсын код",
    phone: "утасны дугаар",
    issuing_country: "Иргэний үнэмлэх олгосон улс, бүс нутгийг сонгоно уу",
    IDtype: "ID төрлийн сонголт",
    residence_card: "Оршин суух үнэмлэх эсвэл иргэний үнэмлэх",
    passport: "паспорт",
    regist: "Бүртгэл",
    is_required: "Энэ нь заавал байх ёстой",
    sign_up: "Бүртгүүлэх",
    residence_front: "Гадаргуугийн байршуулалт",
    residence_back: "Ар тал дээр байршуулах",
    passport_upload: "Паспортаа байршуулна уу",
    error_file: "Зургийг байршуулна уу",
    post_resume: "Намтар бичнэ үү",
    resume_upload: "Анкетыг байршуулах",
    click_upload: "Байршуулахын тулд товшино уу",
    image_drop: "Эсвэл зургийн файлыг чирээд унага",
    select_language: "Эх хэлний сонголт",
    vietnamese: "Вьетнам",
    chinese: "Хятад",
    english: "Англи",
    khmer: "Кхмер",
    indonesian: "Индонез",
    tagalog: "Тагалог хэл",
    burmese: "Бирм",
    hindu: "Хинду",
    lao: "Лао",
    mongolian: "Монгол",
    bengali: "Бенгал",
    sinhala: "Сингал хэл",
    banglodesh: "Бангладеш",
    malay: "Малай",
    nepali: "Непал",
    thai: "Тайланд",
    japanese: "Япон",
    error_lang: "Эх хэлээ сонгоно уу.",
    select_ouccupation: "Ажлын төрлийг сонгох",
    select_max_three: "Та гурваас илүүг сонгох боломжтой.",
    industry_id_1: "Урт хугацааны тусламж үйлчилгээний салбар",
    industry_id_2: "Барилгын цэвэрлэгээний бизнес",
    industry_id_3: "Түүхий эдийн үйлдвэр",
    industry_id_4: "Аж үйлдвэрийн машин үйлдвэрлэлийн салбар",
    industry_id_5: "Цахилгаан болон цахим мэдээлэлтэй холбоотой салбарууд",
    industry_id_6: "Барилгын үйлдвэрлэл",
    industry_id_7: "Усан онгоц үйлдвэрлэх / далайн аж үйлдвэр",
    industry_id_8: "Автомашины засвар үйлчилгээний салбар",
    industry_id_9: "Нисэхийн салбар",
    industry_id_10: "Орон байрны бизнес",
    industry_id_11: "Хөдөө аж ахуй",
    industry_id_12: "Загасны аж ахуй",
    industry_id_13: "Хоол хүнс, ундаа үйлдвэрлэл",
    industry_id_14: "Рестораны бизнес",
    industry: "Аж үйлдвэр",
    error_occupation: "Нэг эсвэл хэд хэдэн ажлын төрлийг сонгоно уу.",
    do: "Хийх",
    news_tpic: "мэдээ",
    days_until_exam: "Шалгалт үлдэх өдрүүд",
    estimated_pass_rate: "Тооцоолсон дамжуулалтын хувь",
    average_score_taken: "Шалгалтын дундаж оноо",
    exam: "Шалгалт нь",
    let_aim: "Зорилго хийцгээе",
    score: "цэг",
    solve_problem: "Асуултаа шийдээрэй",
    recommend_problem: "AELU-ийн санал болгосон асуулт",
    solved_problem: "Асуултыг өнгөрсөн хугацаанд шийдсэн",
    looking_solved: "Өнгөрсөн асуултуудыг шалгана уу",
    application_agency: "Шалгалт өгөх агентлагийн үйлчилгээ",
    billing: "Нэхэмжлэх",
    more_look: "Илүү ихийг шалгах",
    more_look2: "Илүү ихийг шалгах",
    facebook: "Facebook",
    google: "Google",
    until_not_account: "Хэрэв танд одоохондоо данс байхгүй бол",
    or: "эсвэл",
    other_way: "Бусад аргаар",
    not_have_account: "Хэрэв танд данс байхгүй бол",
    have_account: "Хэрэв танд данс байгаа бол",
    forgot_password: "Хэрэв та нууц үгээ мартсан бол",
    this: "Энд",
    at_login: "Нэвтрэх",
    pass_condition: "8 ба түүнээс дээш нэг байт цагаан толгойн том үсэг",
    at_sign_up: "Шинэ бүртгэл",
    agreement1: "Дараахь зүйлийг зөвшөөрч, үргэлжлүүлэхийг сонгосноор AELU",
    terms: "Үйлчилгээний нөхцөл",
    agreement2: "Чамтай санал нэг байна.",
    agree: "Зөвшөөрч үргэлжлүүлээрэй",
    account_confirm: "Баталгаажуулах код",
    confirm: "Баталгаажуулалт",
    not_confirm: "Баталгаажуулах код баталгаажаагүй байна.",
    move_confiirm: "Баталгаажуулах код оруулах дэлгэц рүү шилждэг",
    top: "Топ",
    news_list: "мэдээний жагсаалт",
    problim_list: "Асуултын жагсаалт",
    learning_consul: "Суралцах зөвлөгөө",
    agency: "Шалгалтын мэдээлэл",
    of_trend: "Туршилтын чиг хандлагын талаар",
    start_test: "Туршилтыг эхлүүлээрэй",
    study_mode: "Сурах горим",
    order_question: "Асуулт",
    of_question: "Асуултанд нь",
    question_current: "Асуултын зөв хариулт",
    to_mypage: "Миний хуудас руу",
    correct_answer: "Зөв хариулт!",
    correct_answer_normal: "Зөв хариулт",
    no_correct_answer: "Буруу хариулт",
    next: "Дараагийн асуултанд",
    finish_all: "Бүх асуултанд хариулав!",
    your_score: "Таны оноо",
    is: "байна!",
    result_description: "Та бусад асуултуудыг харах асуултуудын жагсаалтаас шийдвэрлэх боломжтой. Та мөн асуултуудын жагсаалтын хуудаснаас урьд өмнө шийдэж байсан асуултуудаа эргэн харах боломжтой.",
    back_quiz_list: "Асуултуудын жагсаалтыг шалгана уу",
    retry: "Энэ асуултуудыг дахин шийдээрэй",
    no_description: "Тайлбар алга",
    show_ans: "Хариултыг шалгана уу",
    of_solved_problem: "Асуултыг өнгөрсөн хугацаанд шийдсэн",
    of_solved_problem_list: "Өнгөрсөн хугацаанд шийдсэн асуултуудын жагсаалт",
    solved_description: "Та урт хугацааны тусламж үйлчилгээний салбарын ур чадварын визний тодорхой шалгалтын талаархи сургалтын тестийг дахин шалгаж болно.",
    before_result: "Өмнөх үр дүнгүүд",
    looking_back: "дахин шалгах",
    back_solved_problem_list: "Өнгөрсөн хугацаанд шийдсэн асуултуудын жагсаалтыг шалгана уу",
    again_retry: "Энэ асуултыг дахин эргэж харах",
    done_member_regist: "Гишүүнээр бүртгүүлсэнд баярлалаа!",
    done_member_regist_description: "Үйлчилгээний төлбөрийг төлсний дараа үйлчилгээ бүр боломжтой болно. \nТөлбөрийн мэдээллээ бүртгүүлнэ үү.",
    choose_payment: "Төлбөрийн аргыг сонгоно уу",
    service_content: "Үйлчилгээний агуулга",
    test_info_service: "Шалгалтын мэдээллийн үйлчилгээ",
    usage_fee: "ашиглалтын төлбөр",
    test_fee: "500 иен + татвар",
    application_fee: "20000 иен + татвар",
    method_payment: "төлбөрийн нөхцөл",
    LINE_pay: "Шугамын төлбөр",
    line_pay_description: "* QR кодын дүрсийг хадгалж, LINE Pay үйлчилгээний хүрээнд төлбөрөө хийгээрэй. LINE Pay-р төлбөр хийхдээ удирдлагын зүгээс баталгаажуулахад хугацаа шаардагдана.",
    save_qr: "QR кодыг хадгалах",
    next_stage: "дараачийн",
    credit_card: "зээлийн карт",
    copmplete_payment: "Төлбөр дууссан.",
    copmplete_payment_descript: "Төлбөр дууссан тул та онлайн шалгалтын сургалтын функц, шалгалтын мэдээлэл, шалгалт өгөх агентлагийн үйлчилгээг ашиглах боломжтой.",
    start_sevice: "Үйлчилгээг ашиглаж эхэлнэ үү",
    to_payment: "Төлбөрийн дэлгэц рүү",
    of_news_list: "мэдээний жагсаалт",
    done_payment: "Төлбөр дууссан.",
    tv_consult: "Видео утасны зөвлөгөө",
    tell_consult: "Утасны зөвлөгөө",
    learning_consul_descript01: "Шалгалтын өргөдөл",
    learning_consul_descript02: "Бид таны өмнөөс ажиллах болно",
    money_unit: "JPY",
    learning_consul_unit: "Нэг удаа",
    fault_payment1: "Төлбөр амжилтгүй боллоо.",
    fault_payment2: "Дахин оролдоно уу.",
    no_examination: "Хараахан болоогүй",
    no_exam: "Одоогоор шалгалт өгөхгүй",
    undecided: "Шийдвэргүй",
    retry_login: "Дахин нэвтэрнэ үү",
    no_problem: "Асуулт шийдэгдээгүй байна",
    do_problem: "Асуултаа шийдээрэй",
    qa_title: "Түгээмэл асуултууд",
    search_category: "Ангилалаар нарийс",
    search_freeward: "Үнэгүй үгээр хайх",
    test_result: "Туршилтын үр дүнг дасгал хий",
    to_top: "Дээд талд",
    missPassword: "Нууц үг эсвэл имэйл хаяг буруу байна",
    sample_problem: "Онлайн шалгалтанд суралцаж байсан туршлагатай",
    exercises: "Дасгал",
    let_exercises: "Ганц бодит асуудлыг шийдэцгээе!",
    to_qa: "Бусад асуулт, хариултыг шалгана уу",
    read_more: "Илүү ихийг шалгах",
    account_setting: "Дансны тохиргоо",
    profile_setting: "Профайл тохиргоо",
    notification_setting: "Мэдэгдлийн тохиргоо",
    logout: "Гарах",
    changeEmail: "Имэйл хаягаа солих",
    changePassword: "Нууц үгээ солих",
    change: "өөрчлөх",
    save: "хадгалах",
    change_success: "Өөрчлөлт дууссан",
    now_password: "Одоогын Нууц Үг",
    new_password: "шинэ нууц үг",
    check_new_password: "Шинэ нууц үг (баталгаажуулалт)",
    do_logout: "гарсан",
    done_learning_consul_payment: "Төлбөрийг аль хэдийн дуусгасан байна.",
    past_exam: "Өнгөрсөн асуултууд",
    update_info: "Хамгийн сүүлийн үеийн мэдээллийг шинэчилж байна",
    official_sns: "Албан ёсны SNS",
    privacy_policy: "нууцлалын бодлого",
    terms_service: "Үйлчилгээний нөхцөл",
    transaction_law: "Тодорхой арилжааны гүйлгээний тухай хуульд үндэслэсэн тэмдэглэгээ",
    selectCountry: "Улсаа сонгоно уу",
    goInquiry: "Лавлагаагаа үргэлжлүүлээрэй",
    lineInquiry: "LINE-ээр холбогдоорой",
    regist_accept_certificate: "Тодорхой ур чадварын виз авах үнэмлэхийн бүртгэл",
    accept_certificate_description: "Та паспортын гэрчилгээ, дугаараа бүртгүүлж болно",
    accept_certificate: "Хүлээн зөвшөөрсөн гэрчилгээ",
    accept_number: "Дамжуулах дугаар",
    immigration_resume: "Орох үед бүртгэлээ үргэлжлүүлээрэй",
    resendCode: "Баталгаажуулах кодыг дахин илгээнэ үү",
    line_at_register: "LINE @ -аар дамжуулан үйлчилгээний лавлагаа.",
    study: "Судлаад дахин шалгана уу",
    study_text: "Сурах текстийг татаж авах",
    do_resume_update: "Анкетаа байршуулна уу",
    done_resume_update: "Анкетаа бүртгүүлсэнд баярлалаа!",
    regist_resume_enter: "Анкетыг нэвтрэх үед бүртгэх",
    about_company: "Үйл ажиллагаа явуулж буй компанийн тухай",
    add_exam_info_detail: "Шалгалтын мэдээлэл нэмэгдсэн. Дэлгэрэнгүй мэдээлэл, өргөдлийг эндээс авна уу",
    regist_result_get_money: "Шалгалтын дүнгээ бүртгүүлж мөнгөө аваарай",
    detail: "Дэлгэрэнгүй мэдээлэл",
    about_withdrawal_subsc: "Захиалгыг цуцлах, цуцлах тухай",
    apply_withdrawal: "Бүртгэлээс хасах өргөдөл",
    apply_subsc: "Захиалгад бүртгүүлэхээс татгалзах өргөдөл",
    about_withdrawal: "Татаж авах өргөдөл",
    about_subsc: "Захиалгаас захиалгаа цуцлах",
    exam_info: "Шалгалтын мэдээлэл",
    date: "Огноо, цаг",
    day: "Өдөр",
    place: "газар",
    result_publication: "үр дүнгийн нийтлэл",
    result_publication_place: "Үр дүнг зарлах газар",
    result_this_page: "Энэ хуудсан дээр зарлах болно",
    exam_way: "Шалгалтын хэлбэр",
    exam_way2: "Шалгалтын асуултын хэлбэр",
    include_exam_fee: "Шалгалтын хураамж орно",
    exam_application_desc: "Шалгалтын анкет бөглөх. \n Шалгалтын албатай харилцах \n Өдөрт юу бэлдэх талаар холбоо барих (LINE @) \n Шалгалттай холбоотой асуулт байвал зөвлөгөө авна.",
    self_application: "Өөрөө өргөдөл гарга",
    application_method: "Хэрхэн өргөдөл гаргах вэ",
    under_this_url: "Дараахь хаягаас өргөдлийн журмыг бөглөнө үү.",
    do_appliction: "Шалгалтанд хамрагдах",
    study_with_aeru: "Шалгалтын түвшинг дээшлүүлэхийн тулд шалгалтын судалгааны функцийг дээд хуудаснаас ашиглана уу.",
    line_at_consul: "LINE @ сургалтын зөвлөгөө өгөх үйлчилгээ",
    instagram: "Instagram",
    do_signup: "Та гэрчлэгдсэн байна. \n Дахин нэвтэрнэ үү.",
    gender: "Хүйс",
    man: "Эрэгтэй",
    woman: "Эмэгтэй",
    input_problem_title: "Асуудлын гарчгийг агуулсан ...",
    still_no_problem: "Асуудалгүй",
    enter_in_problem_trend: "Шалгалтын өнөөгийн чиг хандлага, хариултын хэлбэр (сонгох хэлбэр) зэрэг шалгалтын товч тайлбарыг багтаасан болно.",
    correct: "Зөв хариулт",
    explanation: "Тайлбар",
    problem: "асуулт",
    do_nursing_not_published: "Шалгалтыг урт хугацааны тусламж үйлчилгээний салбарт явуулж байгаа боловч өнгөрсөн асуултууд хэвлэгдээгүй байна.",
    practical_exam_of_year: "Жилийн практик тест",
    judgment_test_of_year: "2019 оны Шүүлтийн шалгалт",
    judgment_test_answer_of_year: "2019 оны Шүүхийн шалгалтын хариу",
    not_yet_test_material: "Түүхий эдийн үйлдвэрлэлийн шалгалт хараахан болоогүй байна",
    not_yet_test_machinery: "Аж үйлдвэрийн машин үйлдвэрлэлийн салбарт шалгалт хараахан болоогүй байна",
    not_yet_test_electronic: "Цахилгаан, цахим мэдээлэлтэй холбоотой салбарын шалгалт хараахан болоогүй байна",
    not_yet_test_construction: "Барилгын салбарын шалгалт хараахан болоогүй байна",
    not_yet_test_shipbuilding: "Усан онгоцны үйлдвэр ба далайн үйлдвэрлэлийн шалгалт хараахан болоогүй байна",
    do_automobile_not_published: "Автомашины засвар үйлчилгээний чиглэлээр шалгалт явуулж байгаа боловч өмнө нь тавьсан асуултууд нийтлэгдээгүй байна.",
    do_aviation_not_published: "Шалгалтыг нисэхийн салбарт явуулж байгаа боловч өмнө нь тавьсан асуултууд хэвлэгдээгүй байна.",
    do_agricultural_not_published: "Хөдөө аж ахуйн салбарт шалгалт явуулж байгаа боловч өнгөрсөн асуултууд хэвлэгдээгүй байна.",
    do_fishery_not_published: "Загасны аж ахуй эрхлэх чиглэлээр шалгалт явуулж байгаа боловч өнгөрсөн асуултуудыг нийтлээгүй байна.",
    do_food_not_published: "Хоол хүнс, ундаа үйлдвэрлэлийн салбарт шалгалт явуулж байгаа боловч өнгөрсөн асуултууд нийтлэгдээгүй байна.",
    do_restaurant_not_published: "Шалгалтыг хүнсний үйлчилгээний салбарт явуулж байгаа боловч өмнө нь тавьсан асуултууд хэвлэгдээгүй байна.",
    schedule_undecided: "(* Хуваарь шийдээгүй байна)",
    year: "Он",
    month: "Сар",
    texts_learning: "Салбар бүрийг сурахад зориулсан сурах бичиг",
    texts_learning_test: "Ур чадварын үнэлгээний шалгалтын сургалтын текст (Япон)",
    skill_test_sample: "Ур чадварын үнэлгээний шалгалтын түүвэр",
    japanese_test_sample: "Японы үнэлгээний шалгалтын жишээ",
    not_building_texts: "Барилга цэвэрлэх үйлдвэрлэлийн талаар сурах сурах бичиг одоохондоо байхгүй байна.",
    not_material_texts: "Түүхий эд үйлдвэрлэлийн чиглэлээр сурах сурах бичиг одоохондоо байхгүй байна.",
    not_machinery_texts: "Аж үйлдвэрийн машин үйлдвэрлэлийн чиглэлээр сурах сурах бичиг хараахан байхгүй байна.",
    not_electronic_texts: "Цахилгаан, цахим мэдээлэлтэй холбоотой үйлдвэрлэлийн талаар сурах сурах бичиг хараахан байхгүй байна.",
    not_shipbuilding_texts: "Усан онгоц үйлдвэрлэх / далайн үйлдвэрлэлийн чиглэлээр сурах сурах бичиг хараахан байхгүй байна.",
    not_automobile_texts: "Автомашины засвар үйлчилгээний салбарт сурах сурах бичиг хараахан байхгүй байна.",
    not_accommodation_texts: "Орон байрны үйлдвэрлэлийн талаар сурах сурах бичиг хараахан байхгүй байна.",
    not_food_texts: "Хүнс, ундаа үйлдвэрлэлийн салбарт сурах сурах бичиг хараахан байхгүй байна.",
    not_restaurant_texts: "Хоолны үйлчилгээний ур чадварыг хэмжих шалгалтын сурах бичиг",
    each_depertment_texts: "Тэнхим тус бүрт шалгалт сурахад зориулсан сурах бичиг",
    skill_test_basic: "Ур чадварын үнэлгээний шалгалтын сургалтын текст (үндсэн технологи)",
    skill_test_safety: "Ур чадварын үнэлгээний шалгалтын сургалтын текст (ажлын аюулгүй байдал / чанар)",
    skill_test_aircraft: "Ур чадварын үнэлгээний шалгалтын сургалтын текст (агаарын хөлгийн тойм)",
    texts_livestock: "[Мал аж ахуй эрхлэх сурах бичиг] Япон хувилбар",
    texts_cultivated: "[Газар тариалангийн хөдөө аж ахуйд суралцах текст] Япон хувилбар",
    skill_test_fishery: "Загас агнуурын ур чадварыг хэмжих шалгалт (загасны аж ахуй)",
    skill_test_general_fishery: "Загас агнуурын ур чадварыг хэмжих шалгалт (ерөнхий загасчлал)",
    skill_test_safety_fishery: "Загас агнуурын ур чадварыг хэмжих шалгалт (загас агнуурын аюулгүй байдал)",
    skill_test_specialty_fishery: "Загас агнуурын ур чадварыг хэмжих шалгалт (загас агнуурын төрөлжсөн сүлжээтэй холбоотой)",
    skill_test_related_fishery: "Загас агнуурын ур чадварыг хэмжих шалгалт (загас агнуурын төрөлжсөн загасчлалтай холбоотой)",
    skill_test_aquaculture: "Загас агнуурын ур чадварыг хэмжих шалгалт (загасны аж ахуй)",
    skill_test_general_aquaculture: "Загасны ур чадварыг хэмжих шалгалт (Aquaculture General / Safety)",
    skill_test_feeding_aquaculture: "Загасны аж ахуй эрхлэх ур чадварыг хэмжих шалгалт (хооллох, загасны аж ахуй)",
    skill_test_non_feeding_aquaculture: "Загасны аж ахуй эрхлэх ур чадварыг хэмжих шалгалт (загасгүй загастай холбоотой)",
    registration_skill_visa: "Ур чадварын тодорхой виз хүлээн авсны гэрчилгээний бүртгэл",
    please_register_pdf_number: "Тодорхой ур чадварын виз авахын тулд үнэмлэхний зураг эсвэл PDF-ийг бүртгүүлж, гэрчилгээний үнэмлэх дээрх нэвтрэх дугаарыг авна уу.",
    regist_and_get_cash_bag: "Хэрэв та одоо бүртгүүлсэн бол бэлэн мөнгөний уутаар 5000 иен авах боломжтой.",
    thank_you_regist_visa_pass: "Ур чадварын тодорхой виз мэдүүлсэн тухай гэрчилгээг бүртгүүлсэнд баярлалаа!",
    exam_info_detail: "Шалгалтын хэрэгжилтийн тойм",
    em_exam_detail_language: "Орон нутгийн хэл дээр хийхээр төлөвлөсөн",
    em_exam_detail_method: "Хэлтсийн шалгалт, практик шалгалт",
    em_exam_detail_way: "Компьютерт суурилсан тестийн (CBT) цаасны туршилтын арга буюу үйлдвэрлэл гэх мэт ажлын туршилтын арга",
    em_exam_detail_section: "Шалгалтын 19 ангилал (цутгамал, хуурамч, цутгамал цутгамал, боловсруулалт хийдэг, төмөр дардаг, төмрийн эдлэл, үйлдвэрийн төмөр, өнгөлгөө, хөнгөн цагаан аноджуулалт, өнгөлгөө, механик үзлэг, машины засвар үйлчилгээ, электрон төхөөрөмжийн угсралт, цахилгаан тоног төхөөрөмжийн угсралт, хэвлэмэл утасны самбар үйлдвэрлэх, хуванцар хэвлэх. , зураг, гагнуур, үйлдвэрлэлийн сав баглаа боодол)",
    em_exam_detail_notify: "Шалгалтын дараа дүнгийн мэдэгдлийг имэйлээр илгээнэ үү.",
    em_exam_detail_border: "Тасгийн тест: 65% ба түүнээс дээш \n Практик тест: 60 ба түүнээс дээш оноо",
    ss_exam_detail_language: "Япон",
    ss_exam_detail_method: "Ур чадварын шалгалтыг практик шалгалт, тэнхимийн шалгалтаар явуулдаг. \n Практик шалгалтыг бизнесийн төрөл тус бүрээр явуулдаг. \n Тэнхимийн шалгалтыг бизнес ангилал тус бүрт цаасан туршилтын аргаар явуулдаг.",
    ss_exam_detail_way: "Цаасан туршилтын арга гэх мэт.",
    ss_exam_detail_section: "Тэнхим / Дадлага / Ур чадвар: Гагнах, будах, төмрийн хийц, өнгөлгөө, боловсруулалт, цахилгаан тоног төхөөрөмж угсрах",
    ss_exam_detail_notify: "-",
    ss_exam_detail_border: "Тасгийн шалгалт: 60% ба түүнээс дээш \n Практик тест: Практик үр дүнд үндэслэсэн шүүлт",
    c_exam_detail_language: "Япон",
    c_exam_detail_method: "Ур чадварын шалгалтыг практик шалгалт, тэнхимийн шалгалтаар явуулдаг.",
    c_exam_detail_way: "Компьютерт суурилсан тест (CBT), практик тест нь бүртгэгдсэн корпорацаас тогтоосон арга юм",
    c_exam_detail_section: "-",
    c_exam_detail_notify: "Вэбсайт дээр нийтлэгдсэн",
    c_exam_detail_border: "Тасгийн шалгалт: 65% ба түүнээс дээш \n Практик тест: Практик үр дүнд үндэслэсэн шүүлт",
    cm_exam_detail_language: "Япон",
    cm_exam_detail_method: "Ур чадварын шалгалтыг практик шалгалт, тэнхимийн шалгалтаар явуулдаг.",
    cm_exam_detail_way: "Эрдэм шинжилгээний болон практик шалгалтуудыг компьютерт суурилсан тест (CBT) -ээр гүйцэтгэх",
    cm_exam_detail_section: "Сэдвийн шалгалтын сэдэв \n Бүтэц, үйл ажиллагаа, харьцах аргын талаархи анхан шатны мэдлэг \n Хяналт, засвар, тохируулгын талаархи анхан шатны мэдлэг \n Туршилтын машин, хэмжих хэрэгсэл, багаж хэрэгслийн бүтэц, үйл ажиллагаа, харьцах аргын талаархи анхан шатны мэдлэг \n Анхан шатны мэдлэг материал, түлш, өөх тосны шинж чанар, хэрэглээний талаар \nПрактик шалгалтын сэдвүүд \nЭнгийн үндсэн ажил \nБ Буулгах, угсрах, энгийн үзлэг, тохируулга хийх \nC Хялбар засвар \nD Засвар үйлчилгээ шалгах машин, хэмжих хэрэгсэл, багаж хэрэгслийг хялбар харьцах.",
    cm_exam_detail_notify: "",
    cm_exam_detail_border: "Тэнхимийн шалгалт: 65% ба түүнээс дээш Практик тест: Нийт оноо 60% ба түүнээс дээш",
    a_exam_detail_language: "Орон нутгийн хэл ба япон хэл",
    a_exam_detail_way: "Компьютерт суурилсан тест (CBT), цаасан тестийн арга",
    a_exam_detail_section: "Тус газар тариалангийн газар тариалангийн ерөнхий байдал, аюулгүй байдал, эрүүл ахуй, таримал ургамлын сорт / шинж чанар, тариалах орчин (байгууламж / тоног төхөөрөмж / материал / машин механизм), тариалах арга / менежмент, хортон шавьж / хог ургамалтай тэмцэх, ургац хураах / тохируулах / хадгалах / тээвэрлэх ②Хөрсний практик ажиглалт, Бордоо / пестицидтэй харьцах, үртэй харьцах, байгаль орчны менежмент, материал / тоног төхөөрөмж / машинтай харьцах, тариалах, аюулгүй байдал, эрүүл ахуйтай холбоотой ажил хийх ③ Япон хэлээр зааварласан хөдөө аж ахуйн ажлын агуулгыг сонсох.",
    a_exam_detail_notify: "Вэбсайт дээр нийтлэгдсэн",
    a_exam_detail_border: "Нийт оноо нь Хөдөө аж ахуйн үндэсний танхимаас тогтоосон шүүлтийн лавлагааны цэгээс давсан байна.",
    avi_exam_detail_method: "Мэргэшлийн шалгалтыг практик шалгалт, тэнхимийн шалгалтаар явуулдаг.",
    avi_exam_detail_section: "Асуултуудыг Японы Нисэхийн технологийн холбооны вэбсайт дээр байрлуулсан текстээс өгөх болно. Практик ур чадварын дүгнэлт, цахилгаан хэмжилт",
    avi_exam_detail_notify: "",
    avi_exam_detail_border: "Тэнхимийн шалгалт: 65% ба түүнээс дээш Практик тест: Нийт оноо 65% ба түүнээс дээш",
    f_exam_detail_language: "Япон",
    f_exam_detail_method: "Ур чадварын шалгалтыг практик шалгалт, тэнхимийн шалгалтаар явуулдаг.",
    f_exam_detail_way: "Эрдэм шинжилгээний болон практик шалгалтуудыг компьютерт суурилсан тест (CBT) -ээр гүйцэтгэх",
    f_exam_detail_section: "Загасны аж ахуй (загасны аж ахуй) эсвэл загасны тариалангийн талбай (усны аж ахуй) дахь тодорхой хэмжээний ажлыг удирдагчийн зааврыг ойлгоно, эсвэл өөрийн үзэмжээр гүйцэтгэж болно, зөвхөн мэргэшсэн гэдгийг туршилтад хамрагдсан хүн баталгаажуулна. . Энэ нь мэдлэг байгаа эсэх талаархи үнэлгээ биш бөгөөд харин загасны аж ахуй (загасны аж ахуй) эсвэл загасны аж ахуй (усны аж ахуй) -д ажил хийхэд шаардлагатай зөв дүгнэлт, ажлын мэдлэг байгаа эсэхийг үнэлэх боломжтой юм.",
    f_exam_detail_notify: "Вэбсайт дээр нийтлэгдсэн",
    f_exam_detail_border: "Бичгийн болон практик шалгалтын нийт оноо нь ур чадварын шалгалт гүйцэтгэгч байгууллагаас тогтоосон шүүлтийн стандарт онооноос хэтэрсэн хүмүүсийг хүлээн авна.",
    no_exam_info: "Туршилтын тойм мэдээлэл хараахан гараагүй байна",
    language: "Хэрэгжүүлэх хэл",
    method: "Хэрэгжүүлэх арга",
    way: "Хэрэгжүүлэх арга",
    section: "Exmmination ангилал",
    notify: "Шалгалтын үр дүнгийн талаархи мэдэгдэл",
    border: "Шалгалтын дүнгийн шалгуур",
    go_line_at: "Мөрөнд @",
    thank_you_and_deactivate: "Ашигласанд баярлалаа Үйлчилгээнээс гарах журмын дагуу доорх мөр @ цонхноос гарах журмыг оруулна уу. Ердийн төлбөрийг цуцлахын тулд доорх мөр @ цонхноос ердийн төлбөрийг цуцлахыг оруулна уу. Бид баталгаажуулсны дараа процедурыг гүйцэтгэх болно.",
    thank_you_and_subscribe: "Ашигласанд баярлалаа. Ердийн төлбөрийг цуцлахын тулд доорх мөр @ цонхноос ердийн төлбөрийг цуцлахыг оруулна уу. \n Бид баталгаажуулалтаа хүлээн авмагц гэрээгээ цуцална.",
    ten_thousand_yen: "Арван мянган иен",
    yen_per_month: "JPY / сар",
    how_to_use_this_service: "Ашиглалтын урсгал",
    selecting_a_browser: "Хөтчийн сонголт",
    selecting_a_browser_dec: "Хөтөч ашиглан https://aelu.co.jp хандана уу (Google chrome, Safari, edge гэх мэт.) * Апп байхгүй байна.",
    provisional_registration: "Түр бүртгэл",
    provisional_registration_dec: "Фэйсбүүк эсвэл Google ID-ээр нэвтрэх эсвэл имэйл хаягаараа бүртгүүлнэ үү. Хүссэн хэл, хүссэн мэргэжлээ сонгосны дараа та онлайнаар баталгаажуулах шалгалтын хуурамч агуулгыг үзэх боломжтой.",
    full_registration: "Үндсэн бүртгэл",
    full_registration_dec: "Онлайн баталгаажуулалтын шалгалтын агуулгын хуудсан дээрх Үндсэн бүртгэл дээр дарж, шаардлагатай мэдээллээ бөглөж, салбарын баталгаажуулалтын шалгалтын дадлагын 14 асуулт зэрэг бүх үйлчилгээг ашиглаарай.",
    name_validate_message: "Мэдээллийг паспорт дээр бичигдсэн ижил үсгээр оруулна уу.",
    live_at_area: "Таны одоо амьдардаг газар",
    agency_application: "Шалгалтын өргөдөл гаргах",
    mypage: "Миний Хуудас",
    myanmar: "Бирм",
    exam_list: "Шалгалтын хуваарийн жагсаалт",
    no: "Үгүй",
    times: "Times",
    application_start: "Програмыг эхлүүлэх",
    application_end: "Өргөдөл хүлээн авах эцсийн хугацаа",
    enforcement: "Хэрэгжилт",
    applicated: "Хэрэглээтэй",
    reception_time: "Хүлээн авах цаг",
    announthment_d: "Хүлээн авах тухай зарласан огноо",
    reception_period: "Өргөдөл гаргах хугацаа",
    detail_link: "дэлгэрэнгүй мэдээллийг шалгах",
    exam_country: "Зохион байгуулагч орон",
    line: "ШУГАМ",
    vietnum: "Вьетнам",
    laos: "Лаос",
    malaysia: "Малайз",
    bangladesh: "Бангладеш",
    indo: "Энэтхэг",
    nepal: "Непал",
    mongol: "Монгол Улс",
    indonesia: "Индонези",
    th: "Тайланд",
    philipine: "Филиппин",
    my: "Мьянмар",
    uzbekistan: "Узбекистан",
    pakistan: "Пакистан",
    japan: "Япон",
    news_title: "Ур чадварын тодорхой визний тухай мэдээ",
    missNowPassword: "Одоогийн нууц үг буруу байна",
    article6_sub2_dec2: "Хэрэв та энд өргөдөл гаргасан бол бид шалгалтын өргөдөл, эксм-ийн үнэ, байршил зэргийг шалгалтын өдөр хүртэл зарлах болно.",
    create_naw_password: "Нууц үгээ өөрчлөх",
    send_confirmcode: "Баталгаажуулах код илгээсэн",
    edit: "өөрчлөх",
    success_new_password_setting: "Та шинэ нууц үг тохирууллаа.",
    error_email: "Энэ бол бүртгэлгүй имэйл хаяг юм.",

    click_here_businesses: "Бизнес эрхлэгчдийг энд дарж үзнэ үү",
    regist_organization_staff_info: "Бизнесийн болон хэрэглэгчийн мэдээллийн бүртгэл",
    organization_info: "Бизнесийн мэдээлэл",
    staff_info: "Хэрэглэгчийн мэдээлэл",
    org_name: "Бизнес нэр",
    url: "URL",
    org_scale: "масштаб",
    org_zip: "Шуудангийн код",
    org_adress1: "Мужууд",
    org_adress2: "Хотын захиргаа",
    org_adress3: "Хаяг / орон сууцны нэр",
    org_industry: "Аж үйлдвэр",
    org_category: "Ангилал",
    org_description: "Тодорхойлолт",
    org_established_at: "Байгуулагдсан он",
    org_phone: "Бизнесийн утасны дугаар",
    failed_established_at: "Огноо буруу байна.",
    staff_name: "хэрэглэгчийн нэр",
    form_miss: "Оруулах хэлбэрт алдаа гарсан байна.",
    back_joboffer_detail: "Ажлын дэлгэрэнгүй мэдээлэл рүү буцах <",
    create_joboffer: "Ажлын байр бий болгох",
    edit_joboffer: "Ажлыг засах",
    stop_posting: "Нийтлэхээ боль",
    delete: "устгах",
    job_title: "Албан тушаал",
    job_catch_phrase: "Ажлын байр барих хэллэг",
    job_category: "Мэргэжлийн ангилал",
    employed_company_name: "Ажиллаж буй компанийн нэр",
    work_location: "Ажлын байршил",
    employment_status: "Хөдөлмөр эрхлэлтийн байдал",
    full_time_employee: "Бүрэн цагийн ажилтан",
    part_time_job: "цагийн ажил",
    temporary_staff: "Ажиллах хүч илгээсэн",
    contract_employee: "Гэрээт ажилтан",
    intern: "Дадлагажигч",
    subcontracting: "Туслан гүйцэтгэгч",
    contract: "Гэрээ",
    new_graduate: "Шинэ төгсөгч",
    salary: "Цалин",
    annual_income: "жилийн орлого",
    monthly_salary: "Сарын цалин",
    weekly_salary: "Долоо хоногийн цалин",
    dayly_salary: "Өдөр тутмын цалин",
    job_offer_attension1: "Ажлын агуулгын хувьд тогтоосон хөдөлмөрийн нөхцөл гэх мэтийг хуульд заасны дагуу тодорхой зааж өгөх шаардлагатай.",
    job_offer_attension2: "Хуулиар тодорхой зааж өгөхийг шаардсан ажлын нөхцөл гэх мэтийг шалгаж, ажлын агуулгыг тодорхойлно уу. (Лавлагаа: Эрүүл мэнд, Хөдөлмөр, халамжийн яам, &quot;Хөдөлмөр эрхэлдэг бүх компаниудад&quot; мужийн Хөдөлмөрийн товчоо)",
    job_offer_attension3: "Хэрэв та зорилтот хүний нас, хүйс, нийгмийн байдлыг хязгаарласан үг хэллэг ашигладаг бол ажлын байр байршуулахгүй байж магадгүй юм.",
    job_offer_attension4: "Нийтлэгдээгүй нийтлэг жишээнүүд: &quot;20-иод онд тавтай морилно уу&quot; &quot;Залуучуудад тавтай морилно уу (залуучууд)&quot; &quot;Эмэгтэйчүүд тавтай морилно уу / хязгаарлагдмал&quot; &quot;Зөвхөн оюутнууд&quot;",
    work_content_appeal: "Ажлын агуулга, давж заалдах цэгүүд",
    work_content_appeal_desc: "Хэрэв та эхлээд давж заалдах цэгүүдийг хэлж өгвөл ажил хайгчдад сонирхолтой байх нь илүү хялбар байх болно.",
    human_resources_seek: "Хүний нөөц",
    human_resources_seek_desc: "Зөвхөн таны хайж буй ур чадвараас гадна ажил хайгчдад ажлын байраа төсөөлөх боломжийг олгодог мэдээллийг дамжуулцгаая.",
    working_hours: "Ажлын цаг",
    traffic_access: "Замын хөдөлгөөнд нэвтрэх",
    traffic_access_desc: "Нийтийн тээврийн мэдээллээс гадна автомашинаар зорчих, ажилчдын зогсоол байгаа эсэх зэрэг мэдээллийг оруулаарай.",
    required: "Албадан",
    optional: "Ямар ч",
    other: "Бусад",
    photo: "Фото зураг",
    upload_video: "Видео байршуулах",
    job_tag: "Ажлын тэмдэг",
    until_select_three: "3 хүртэлх тоог сонгох боломжтой",
    senior_support: "Ахмадын дэмжлэг",
    salary_increase_promotion: "Цалингийн нэмэгдэл / албан тушаал ахих гэж байна",
    no_overtime: "Илүү цагаар ажиллахгүй",
    target_hiring_time: "Зорилтот ажилд авах хугацаа",
    additional_questions: "Нэмэлт асуултууд",
    job_offer_title: "Ажлын нэр",
    public: "Суллах",
    private: "хувийн",
    public_status: "Олон нийтийн статус",
    occupation: "Ажил мэргэжил",
    walfare: "Эмчилгээ / халамж",
    create: "бий болгох",
    hour: "Цаг хугацаа",
    back_mypage: "Миний хуудас руу буцах <",
    job_offers: "Ажлын жагсаалт",
    look_matches: "Тохирох жагсаалтыг үзэх",
    now_public: "Нээлттэй",
    now_private: "Хувийн",
    check: "Баталгаажуулах",
    edit2: "Засах",
    news_detail: "Мэдээний дэлгэрэнгүй",
    prefectures: "Мужууд",
    hokkaido: "Хоккайдо",
    aomori: "Аомори",
    iwate: "Иватэ",
    miyagi: "Мияги",
    akita: "Акита",
    yamagata: "Ямагата",
    fukushima: "Фукушима",
    ibaraki: "Ибараки",
    tochigi: "Точиги",
    gunma: "Гунма",
    saitama: "Сайтама",
    chiba: "Чиба",
    tokyo: "Токио",
    kanagawa: "Канагава",
    niigata: "Нийгата",
    toyama: "Тояама",
    ishikawa: "Ишикава",
    fukui: "Фукуй",
    yamanashi: "Яманаши",
    nagano: "Нагано",
    gifu: "Гифу",
    shizuoka: "Шизуока",
    aichi: "Айчи",
    mie: "Гурвалсан",
    shiga: "Шига",
    kyoto: "Киото",
    osaka: "Осака",
    hyogo: "Хёго",
    nara: "Нара",
    wakayama: "Вакаяама",
    tottori: "Тоттори",
    shimane: "Шимане",
    okayama: "Окаяма",
    hiroshima: "Хирошима",
    yamaguti: "Ямагучи",
    tokushima: "Токушима",
    kagawa: "Кагава",
    echime: "Эхимэ",
    kochi: "Кочи",
    fukuoka: "Фукуока",
    saga: "Сага",
    nagasaki: "Нагасаки",
    kumamoto: "Кумамото",
    oita: "Ойта",
    miyazaki: "Миязаки",
    kagoshima: "Кагошима",
    okinawa: "Окинава",
    sinhalese: "Сингал хэл",
    exam_region: "Мужууд",
    exam_place_list: "Байршлын жагсаалт",
    exam_place_name: "Шалгалтын байрны нэр",
    care_evaluation_test: "Урт хугацааны асрамжийн ур чадварын сургалтын үнэлгээний тест",
    clean_building_test: "Барилгын цэвэрлэгээний салбарын асуудал",
    answer: "хариулах",
    skill_test_measurement: "Ур чадварыг хэмжих тест",
    exam_problem: "шалгалтын асуулт",
    fields: "Тариалангийн талбай, хүнсний ногоо",
    gardening: "Байгууламжийн цэцэрлэгжүүлэлт",
    mushroom: "мөөг",
    fruit: "Жимсний мод",
    dairy: "цагаан идээ",
    poultry: "Шувууны аж ахуй",
    pig: "Гахайн аж ахуй",
    beginner: "Эхлэгч",
    professional: "Мэргэжлийн зэрэг",
    advanced: "Дэвшилтэт",
    technical_training_test: "Техникийн дадлагажигч сургалтын үнэлгээний тест",
    exam_part: "Шалгалтын асуултуудын нэг хэсэг",
    tokoha_fruit: "Токоха жимсний мод",
    deciduous_fruit: "Навчит жимсний мод",
    ver: "Хэвлэл",
    errata: "алдаа",
    form_work: "Хэвний барилгын ажил",
    construction: "Засал чимэглэл",
    tunnel_line: "Туннель хөдөлгөх шугам",
    earth_work: "Газар шорооны ажил",
    loofing: "Дээврийн ажил",
    elecommunication: "харилцаа холбоо",
    reinforcing_contstruction: "Баарны барилгын ажлыг бэхжүүлж байна",
    reinforcing_joint: "Арматурын баарны холболт",
    wall_painting: "Уран зураг (ханын хучилт)",
    board_finish: "Самбарын өнгөлгөө, дотоод засал чимэглэл",
    steeplejack: "Үсрэх",
    spray_insulation: "Шээсний уретан тусгаарлагч",
    marine_civil: "Далайн иргэний инженерийн",
    concrete_pumping: "Бетон шахах",
    construction_machinery: "Барилгын машин механизмын барилгын ажил",
    learning_text: "Текст сурах",
    basic_aircraft: "Нисэх онгоцны технологийн үндсэн дүгнэлт, цахилгаан хэмжилт",
    worksafety_quality: "Ажлын аюулгүй байдал, чанар",
    aircraft_overview: "Нисэх онгоцны тойм",
    fish_general: "Ерөнхийдөө загасны аж ахуй",
    fish_safety: "Загас агнуурын аюулгүй байдал",
    network_relations: "Загасны аж ахуйн төрөлжсөн олс харилцаа",
    fish_relations: "Загасны аж ахуйн төрөлжсөн загасчлалтай холбоотой",
    aquaculture_general: "Усны аж ахуй ерөнхийдөө",
    feeding_aquaculture: "Усны тариалангийн төрөлжсөн газар",
    unfed_aquaculture: "Усны аж ахуйн төрөлжсөн хоолгүй загас",
    attachment: "Хавсралт",
    glossary: "Тайлбар толь",
    feneral_customer: "Хэрэглэгчийн ерөнхий үйлчилгээ",
    food_dring_cooking: "Хоол, ундаагаар хоол хийх",
    hygiene_management: "эрүүл ахуйн менежмент",
    visa_application: "Ур чадварын виз мэдүүлэг",
    certificate_residence_tax: "1. Оршин суугчийн татварын гэрчилгээ (сүүлийн нэг жилийн хугацаанд)",
    salary_income_withholding : "2. Цалингийн орлогоос суутган тооцох хуудсын хуулбар",
    national_health_insured: "3. Эрүүл мэндийн даатгалын үндэсний даатгуулагчийн үнэмлэхний хуулбар (хэрэв тухайн хүн хамрагдсан бол)",
    national_health_payment: "4. Үндэсний эрүүл мэндийн даатгалын шимтгэлийн төлбөрийн гэрчилгээ",
    national_health_receipt: "5. Эрүүл мэндийн үндэсний даатгалын шимтгэлийн баримтын хуулбар",
    technical_intern_training2: "6. Техникийн дадлагын 2-р сургалтыг амжилттай хийж гүйцэтгэсэн болохыг гэрчлэх баримт бичиг",
    need_the_following : "Танд дараахь зүйлсийн аль нэг нь хэрэгтэй байна.",
    pass_certificate_test_specialized : "・ Ур чадварыг үнэлэх тестийн мэргэжлийн ур чадварын шалгалтын шалгалтын гэрчилгээний хуулбар (мэргэжлийн зэрэг)",
    technical_intern_training3: "・ Ур чадварын шалгалтын практик тестийн дамжуулалтын гэрчилгээний хуулбар (3-р анги)",
    evaluation_record_technical_intern: "・ Хэрэв та дээрх шалгалтанд тэнцээгүй бол техникийн дадлагажигч оюутны үнэлгээний тэмдэглэлийг бөглөх шаардлагатай.",
    cartificate_pass_basic_test: "7.6 хувилбарын оронд Япон сангийн Япон хэлний анхан шатны шалгалтын шалгалт өгөх гэрчилгээний хуулбар эсвэл Япон хэлний түвшин тогтоох шалгалт (N4) ба түүнээс дээш шалгалтын шалгалтын гэрчилгээний хуулбарыг ирүүлж болно.",
    change_permission_application: "8. Өөрчлөлтийн зөвшөөрлийн өргөдлийн гэрэл зураг (босоо 4 см х хэвтээ 3 см)",
    resume_data_time_entry: "9. Мэдээллийг оруулах үед үргэлжлүүлэх",
    select_file: "Файлуудыг сонгоно уу",
    description_movie: "Тайлбар видео",
    how_to_use_movie: "Видеог хэрхэн ашиглах талаар",
    movie_news: "1. Ур чадварын тодорхой визний тухай мэдээ",
    movie_exam: "2. Туршилтын өдөр хүртэл үлдсэн хоногийн тоо",
    movie_predict_pass: "3. Тооцоолсон дамжуулалтын хувь",
    movie_ave_study_test: "4. Таны судалсан өөрийн тестийн дундаж оноо",
    movie_similar_exam: "5. Ижил төстэй шалгалтын асуултууд",
    movie_learning_text: "6. Сурах сурах бичиг (сурах бичиг) татаж авах",
    movie_solved_exam: "7. Өнгөрсөн хугацаанд миний шийдсэн асуудлууд",
    movie_pased_exam: "8. Бодит байдлаар гарч ирсэн өнгөрсөн асуудлуудыг үзэх тухай",
    movie_resume_regist: "9. Орох үед бүртгэлээ үргэлжлүүлээрэй",
    movie_pass_document_regist: "10. Ур чадварын шалгалтын хуудсыг бүртгэх",
    movie_agency_service: "11. Шалгалт өгөх агентлагийн үйлчилгээ",
    movie_consule_service: "12. Сургалтын зөвлөгөө өгөх үйлчилгээ",
    description_movie_trans: "Хэрэв та япон хэлнээс өөр хэлээр үзэхийг хүсвэл арааны тэмдгийг товшоод, хадмал орчуулга, автомат орчуулгыг товшоод эх хэлээ сонгоод үзээрэй.",

"cultivated_agriculture_general": "газар тариалан ерөнхийд нь",
"livestock_agriculture": "мал аж ахуй,газар тариалан",
"介護": "асрах сувилахуй",
"ビルクリーニング": "барилгын цэвэрлэгээ",
"建設": "барилга",
"自動車整備": "машины засвар үйлчилгээ",
"航空業": "агаарын тээврийн салбар",
"農業": "хөдөө аж ахуй",
"漁業": "загасны аж ахуй",
"飲食料品製造業": "хүнс үйлдвэрлэлийн салбар",
"外食業": "зоогийн газар, хоолны салбар",
"型枠施工": "барилгын хэвний ажил",
"左官": "барилгын заслын ажил",
"コンクリート圧送": "бетон шахах",
"トンネル推進工": "тунел барих, засварлах ажил",
"建設機械施工": "барилгын машин механизмын ажил",
"大工": "мужаан",
"屋根ふき": "дээврийн ажил",
"電気通信": "харилцаа холбоо",
"鉄筋施工": "барилгын арматур",
"鉄筋継手": "арматур холбох ажил",
"壁装（壁張り）": "ханын цаас наах",
"ボード仕上げ、内装仕上げ": "доторлогоо, дотоод засал",
"とび": "барилгын гадна шат угсралт",
"吹き付けウレタン断熱": "шүршдэг хөөсөн дулаалга хийх",
"海洋土木工": "далайд байгууламж барих",
"航空機の基本技術 締結、電気計測": "онгоцны үндсэн техник технологи цахилгаан хэмжилт",
"作業安全、品質": "ажлын аюулгүй байдал, бүтээгдэхүүний чанар",
"航空機概要": "нисэх онгоцны тухай ерөнхий",
"耕種農業全般": "газар тариалан ерөнхийд нь",
"畜産農業": "мал аж ахуй,газар тарилан",
"漁業一般": "загас агнуур ерөнхий",
"漁業安全": "загас агнуурын аюулгүй байдал",
"漁業専門 綱関係": "мэргэжлийн загас агнуур болон загастай холбоотойа",
"漁業専門 釣り関係": "мэргэжлийн загас агнуур, загас барихтай холбоотой",
"養殖業一般": "загас үржүүлгийн аж ахуй",
"養殖業専門 給餌養殖関係": "мэргэжлийн загас үржүүлгийн аж ахуй, тэжээл өгдөг үржүүлгийн аж ахуйтай холбоотой",
"養殖業専門 無給餌養殖関係": "мэргэжлийн загас үржүүлгийн аж ахуй, тэжээл өгдөггүй үржүүлгийн аж ахуйтай холбоотой",
"接客全般": "үйлчилгээний ажил ерөнхий",
"飲食物調理": "хоол бэлтгэх",
"衛生管理": "эрүүл ахуйн менежмент",
"日本語版": "Япон хэл дээрх хувилбар",
"英語版": "Англи хэл дээрх хувилбар",
"クメール語版": "Канбож хэл дээрх хувилбар",
"インドネシア語版": "Индонез хэл дээрх хувилбар",
"インドネシア語・正誤表": "Индонез хэл, алдааг зассан хүснэгт",
"ネパール語版": "Непал хэл дээрх хувилбар",
"モンゴル語版": "Монгол хэл дээрх хувилбар",
"ビルマ語版": "Бирм хэл дээрх хувилбар",
"ベトナム語版": "Вьетнам хэл дээрх хувилбар",
"タイ語版": "Тайланд хэл дээрх хувилбар",
"テキスト１": "Текст 1",
"テキスト２": "Текст 2",
"テキスト３": "Текст 3",
"テキスト４": "Текст 4",
"テキスト５": "Текст 5",
"ミャンマー(ビルマ)語版": "Мьянмар (Бирм) хэлний хувилбар",
"カンボジア(クメール)語版": "Камбож (Кхмер) хэлний хувилбар",
"ミャンマー語版": "мьянмар хэл дээрх хувилбар",
"中国語版": "Хятад хэл дээрх хувилбар",
"付属資料": "хавсралт бичиг",
"用語集": "хэрэглэгдэх үгийн сан",

invitation_code: "урилгын код",
exam_calender: "шалгалтын хуваарийн хуанли",
move_exam_detail: "Та шалгалтын хуваарийн дэлгэрэнгүй хуудас руу орохыг хүсч байна уу?",
move: "Ачааллаж байна",
plece_select_language: "Хэлээ сонгоно уу",
select: "сонгох",
midle_category: "мэргэжлүүд",
select_industry_description: "Эхэндээ AELU зөвхөн 3 хүртэлх салбарыг сонгох боломжтой тул зөвхөн ажиллахыг хүсэж буй салбараа сонгоно уу. Тийм бол Next товчийг дарна уу",
done_member_regist_description_2: "Одооноос эхлэн AELU нь гэрчилгээ олгох шалгалтуудыг олноор бэлтгэн, тусгай ур чадварын виз авахад дэмжлэг үзүүлэх болно.",
done_member_regist_2: "Гишүүний бүртгэл дууслаа.",
is_exist_user: "Ижил мэйл хаягтай хэрэглэгч аль хэдийнэ байна.",
invitation_code_description: "(Илгээгч байгууллага эсвэл Япон хэлний сургуулиас ирсэн урилгын кодыг оруулна уу, эс бөгөөс зардлын тооцооны дэлгэц гарч ирэх тул оруулахаа мартуузай.)",
pleace_select_region: "Хүлээн авагч мужийг сонгоно уу",
pleace_add_messenger: "Facebook мессежээр бүх холбоог барих тул нэмж оруулахаа мартуузай",
add_messenger_bot: "Мэдэгдэл хүлээн авах",
visa_application_description: "тусгай ур чадварын виз мэдүүлэхэд шаардлагатай бичиг баримт",
check_agree: "Зөвшөөрнө үү",
sample_title: "Энэ бол жишиг гарчиг юм. Та тохируулна уу",
sample_description: "Жишиг тайлбар юм. Та тохируулна уу.",
create_profile_error: "Оролтод алдаа байна. Тухайн зүйлийг шалгана уу",
setting_confirm: "Оруулсан агуулгаа нягталж, бүртгүүлнэ үү",
exam_learning: "Шалгалтанд бэлтгэх",
recommend_problem_solve: "жишиг шалгалт хийх",
of: "-ийн",
see_solved_problem: "өмнө таны хийж байсан шалгалтыг дахин хийх",
past_exam_collection: "өмнө нь гарч байсан шалгалтын асуулт",
any_application_registration: "Төрөл бүрийн өргөдлийн бүртгэл",
mypage_visa_application: "Тусгай ур чадварын визний өргөдөл",
applyt_exam_and_agent: "Шалгалтын бүртгэл болон үйлчилгээний бүртгэл",
myapge_regist_accept_certificate: "Ур чадварын шалгалт болон тэнцсэн сертификатын бүртгэл",
mypage_consultaion_service: "Сургалтын зөвлөгөө, үйлчилгээ",
consultaion_service: "Сургалтын зөвлөгөө өгөх үйлчилгээ",
consult: "Зөвлөгөө өгөх",
of_exam_day: "--шалгалтын өдөр",
your_ave_score: "Таны шалгалтын дундаж оноо",
your_estimated_pass_rate: "таны шалгалтанд тэнцсэн хувь",
your_ave_score_fotter: "Таны шалгалтын дундаж оноо",
your_estimated_pass_rate_fotter: "тэнцэх хамгийн доод хувь",
mypage_study_text: "Сургалтын сурах бичиг татаж авах",
exam_schedule: "Шалгалтын хуваарь",
resident_caption_title: "● Оршин суух үнэмлэх, иргэний үнэмлэхийг байршуулах тухай",
resident_caption: "Улаан хүрээн дэх мэдээллэлд баталгаажуулах боломжтой оршин суух үнэмлэх эсвэл иргэний үнэмлэхийг байршуулна уу. Хүчинтэй оршин суух үнэмлэх эсвэл хугацаа нь дуусаагүй иргэний үнэмлэхээ байршуулна уу. PDF эсвэл JPG форматаар өнгөт зургийг байршуулна уу.",
password_caption_title: "● Нууц үг байршуулах тухай",
password_caption: "улаан хүрээнд байгаатай адилаар нэр, регистрийн дугаар , төрсөн он, сар, өдөр, харьяалал, хүчинтэй байх хугацааг баталгаажуулсан паспортын зургийг байршуулна уу. Хугацаа нь дуусаагүй хүчинтэй паспортыг байршуулна уу. PDF эсвэл JPG форматаар өнгөт зургийг байршуулна уу.",
title_help: "Тусламж",
step3_title_help: "Өөрийн мэдээллээ зөв оруулна уу.",
lineid_input_help: "LINE нээх → Нүүр хуудас → Тохиргоо → Профайл → гүйлгээд ID-г харна уу. Энэ ID-г оруулна уу. Хэрэв та үүсгээгүй бол үүсгээд оруулна уу.",
country_input_help: "Өөрийн улсаа сонгоно уу.",
area_input_help: "Одоо амьдарч буй нутаг дэвсгэрийнхээ улсыг сонгоно уу.",
phone_input_help: "Утасны дугаараа оруулна уу.",
issuing_input_help: "Иргэний үнэмлэхний олгосон газраа сонгоно уу.",
idtype_input_help: "ID төрлийг сонгоно уу. Сонгогдсон хэсгийнхээ зургийг цэвэрхэн авч оруулна уу, Далий эсвэл тасархай зураг авалгүй яг эгцээр нь авна уу",
invitation_input_help: "Хэрэв танд урилгын код байгаа бол оруулна уу.",
exam_menu_help: "Өмнө нь авч байсан шалгалтын асуулттай төстэй асуултууд гарч байна. Шалгалтын асуултуудыг давтан хийж, шалгалтанд бэлдэе.",
past_menu_help: "Өмнө нь таны хийж байсан асуулт байна, алдсан хэсгээ давтана уу,",
pastexam_menu_help: "өмнө нь гарч байсан шалгалтын асуулт",
text_menu_help: "Та сурах бичгүүдийг үзэж, чухал хэсгүүдийг нь судалж, ойлгохгүй байгаа зүйлээ шалган тодруулах боломжтой.",
visa_menu_help: "Бид танд тусгай ур чадварын виз авахад туслах болно. Хэрэв та тусгай ур чадварын виз авахыг хүсвэл энд өргөдөл гаргана уу.",
agency_menu_help: "Бид таны өмнөөс ур чадварын шалгалт өгөх хүсэлт гаргах болно. Хэрэв та тусгай ур чадварын шалгалт өгөхийг хүсвэл энд бүртгүүлнэ үү.",
cer_menu_help: "Хэрэв та тусгай ур чадварын шалгалт өгсөн бөгөөд тэнцсэн гэрчилгээтэй бол энд бүртгүүлнэ үү.",
service_menu_help: "Танд асуух зүйл байвал энэ чатаар холбогдоно уу.",
occu_title_help: "Хүссэн 3 хүртэлх мэргэжлээ сонгоно уу.",
back: "буцах",
before: "Өмнөх асуудал руу",
srilank: "Шри Ланка",
reselect: "Хэрэв та файлаа өөрчлөхийг хүсвэл &quot;Паспортоо байршуулах&quot; товчийг дахин дараад дахин сонгоно уу",
iphone_file: "Iphone-ийн хувьд HEIC файлаас JPG файл руу хөрвүүлсний дараа ашиглана уу.",
file_transmit: "Файл хөрвүүлэх",
combodia: 'combodia',

}
